(function () {
  const request = new XMLHttpRequest();

  request.open('GET', '/assets/data/features.json', true);

  request.onload = function () {
    // parse a date in yyyy-mm-dd hh:mm:ss format
    function parseDate(input) {
    const dateSplit = input.split(' ');
    const dateParts = dateSplit[0].split('-');
    const timeParts = dateSplit[1].split(':');
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2],
        timeParts[0], timeParts[1], timeParts[2]); // Note: months are 0-based
    }
    // randomize array.
    function shuffle(array) {
      var currentIndex = array.length,  randomIndex;
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }
      return array;
    }

    if (request.status >= 200 && request.status < 400) {
      const features = JSON.parse(request.responseText);

      // Current time
      const now = new Date();

      // Filter future date features only
      const activeFeatures = features.filter((feature) => {
        const endDate = parseDate(feature.end_date);
        return endDate.getTime() > now.getTime();
      });

      const randomFeatures = shuffle(activeFeatures);
      
      const items = [];
      const indicators = [];

      randomFeatures.forEach((feature, i) => {
        // Add a preload element to the head for the first active feature
        if (i === 0) {
          const preloadEl = document.createElement('link');
          preloadEl.rel = 'preload';
          preloadEl.as = 'image';
          preloadEl.href = feature.banner.path;
          document.head.appendChild(preloadEl);
        }

        // Create nodes
        const card = document.createElement('div');
        if (i === 0) {
          card.className = 'carousel-item card active';
        } else {
          card.className = 'carousel-item card';
        }

        const link = document.createElement('a');
        link.href = feature.link;
        link.setAttribute('data-ga-event-category', 'link - home');
        link.setAttribute('data-ga-event-action', 'featured');
        link.setAttribute('data-ga-event-label', feature.heading);

        const bannerLink = link.cloneNode(true);
        card.appendChild(bannerLink);

        const banner = document.createElement('img');
        banner.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        banner.setAttribute('data-src', feature.banner.path);
        banner.alt = feature.banner.alt;
        if (i === 1) { // 2nd image gets class to lazy preload
          banner.className = 'card-img-top lazyload lazypreload';
        } else {
          banner.className = 'card-img-top lazyload';
        }
        bannerLink.appendChild(banner);

        const cardBody = document.createElement('div');
        cardBody.setAttribute('class', 'card-body');
        card.appendChild(cardBody);

        const cardTitle = document.createElement('h3');
        cardTitle.className = 'card-title h5 no-toc';
        cardBody.appendChild(cardTitle);

        const titleLink = link.cloneNode(true);
        titleLink.textContent = feature.heading;
        cardTitle.appendChild(titleLink);

        const cardText = document.createElement('div');
        cardText.className = 'card-text small';
        cardText.innerHTML = feature.copy;
        cardBody.appendChild(cardText);

        //const learnMore = document.createElement('p');
        //learnMore.style.position = 'relative';
        //learnMore.style.zIndex = '1000';
        //cardText.appendChild(learnMore);

        //const textLink = link.cloneNode(true);
        //textLink.textContent = 'learn more';
        //learnMore.appendChild(textLink);

        items.push(card);

        // Create indicators and append to DOM
        const indicator = document.createElement('li');
        indicator.setAttribute('data-target', '#feature-wrapper');
        indicator.setAttribute('data-slide-to', `${i}`);
        if (i === 0) {
          indicator.className = 'active';
        }
        const indicatorInner = document.createElement('span');
        indicatorInner.className = 'sr-only';
        indicatorInner.textContent = `Go to slide ${i + 1} of ${randomFeatures.length}`;
        indicator.appendChild(indicatorInner);

        indicators.push(indicator);
      });

      const featuredItemsEl = document.getElementById('featured-items');
      const featureIndicatorsEl = document.getElementById('feature-indicators');

      items.forEach((item) => {
        featuredItemsEl.appendChild(item);
      });

      indicators.forEach((indicator) => {
        featureIndicatorsEl.appendChild(indicator);
      });

      if (randomFeatures.length <= 1) {
        document.getElementById('featured-previous').style.display = 'none';
        document.getElementById('featured-next').style.display = 'none';
        document.getElementById('feature-indicators').style.display = 'none';
      }
      if (randomFeatures.length === 0) {
        document.getElementById('featured-items').textContent = 'No current features.';
        console.log('Feature request returned no features.');
      }
    } else {
      document.getElementById('featured-items').textContent = 'No current features.';
      console.log('Feature request status is bad.');
    }
  };

  request.onerror = function () {
    document.getElementById('featured-items').textContent = 'No current features.';
    console.log('Feature request resulted in error');
  };

  request.send();
}());

// Event binding to lazy preload images after carousel moves
(function defer(method) {
  if (window.jQuery) {
    $('#feature-wrapper').on('slid.bs.carousel', () => {
      $('.carousel-item.active').next().find('.lazyload').addClass('lazypreload');
    });
  } else {
    setTimeout(() => { defer(method); }, 50);
  }
}());
